<template>
 
  <div style="max-width:100%;">
     <img :src="imageUrl" @click="goPages" style="width:100%">
    
  </div>
 

</template>
<script>
import cookie from "@utils/store/cookie";
import { getLogo} from "@api/user";
import { postOrderIsVip} from "@api/order";

export default {
  name: "Prview",
  components: {
  },
  props: {},
  data: function() {
    return {
      imageUrl:""
    };
  },
  computed: {
    
  },
  mounted: function() {
    this.getLogo();
  },
  methods: {
    getLogo(){
        let that = this;
        getLogo().then(res => {
              this.imageUrl=res.data;
        });
    },
    goPages:function(item){
        //请求服务器数据
        this.$router.push({path: '/'});
          // postOrderIsVip(1, {}).then(res => {
          //     const data = res.data;
          //     if(data==null){
          //       // this.$router.push({path: '/user/vip'});
          //       this.$router.push({path: '/'});
          //     }else{
          //       //会员
          //       this.$router.push({path: '/'});
          //       // this.$router.push({path: '/video/videoInfo/'+item.id,query: { cateName: item.cateName }});
          //     }

              
          // }).catch(err => {
          //     console.log(err);
          // });
    }

  }
};
</script>
<style scoped>
.title {
  padding: 0 0.3rem;
  font-size: 0.28rem;
  color: #282828;
  height: 0.8rem;
  line-height: 0.8rem;
  border-bottom: 0.01rem solid #f5f5f5;
  text-align:center;
}
.index {
  background-color: #fff;
}
.text .new-name {
  text-align: center !important;
  vertical-align: top;
}
.text .name .icon-shoucang {
  color: #ea3526 !important;
  margin-right: 0.1rem;
}
.text .name .icon-xinpin {
  color: blue !important;
}
.text .name .icon-jingpintuijian {
  color: blue !important;
}
</style>



<style scoped lang="scss">
	    .searchBar {
	        width: 100%;
	        .isFixed {
	            position: fixed;
	            width: 100%;
	            top: 0;
	            left: 0;
	            z-index: 999;
	        }
	        ul {
	            height: 40px;
	            line-height: 40px;
	            display: flex;
	            margin:0;
	            padding: 0;
	
	            li {
	                font-size: 0.8rem;
	                flex: 1;
	                display: flex;
	                justify-items: center;
	                justify-content: center;
	                align-items: center;
	                align-content: center;
	                position: relative;
	                background-color: #fff;
	                &.active {
	                    color: #847ec3;
	                    background-color: #e2e2e2;
	                    &:after {
	                        content: " ";
	                        position: absolute;
	                        height: 1px;
	                        width: 30px;
	                        bottom: 6px;
	                        left:calc(50% - 15px);
	                        border-top: 2px #847ec3 solid;
	                    }
	                }
	            }
	        }
	    }
	
	</style>